// extracted by mini-css-extract-plugin
export default {"posts__cards":"posts_posts__cards__TYc0l","posts__cards_inner":"posts_posts__cards_inner__rl-et"};